import { computed } from 'vue'
import { useWorkspaceStore } from '@/modules/workspace/stores/workspace-store'

const hidden_keys: Record<string, string[]> = {
  elpiscapital: [
    'investments.cash_position',
    'investments.initial_value',
    'investments.roi',
    'investments.moic',
    'investments.initial_price',
    'investments.initial_shares',
    'investments.initial_capital',
    'investments.distributions',
    'investments.accrued_interest',
  ],
}

// One flag per key in hidden_keys.
export type HiddenMetrics = {
  cashPosition: boolean
  initialValue: boolean
  roi: boolean
  moic: boolean
  initialPrice: boolean
  initialShares: boolean
  initialCapital: boolean
  distributions: boolean
  accruedInterest: boolean
}

export const useHiddenMetrics = () => {
  const workspaceStore = useWorkspaceStore()

  // Gated data is hidden from everyone, admins included.
  const isDataAccessible = (key: string) => {
    const subdomain = workspaceStore.current?.subdomain
    if (!subdomain) return true // no workspace loaded → treat as accessible
    const keys = hidden_keys[subdomain]
    if (!keys?.length) return true // workspace gates nothing → accessible
    return !keys.includes(key)
  }

  const hidden = computed<HiddenMetrics>(() => ({
    cashPosition: !isDataAccessible('investments.cash_position'),
    initialValue: !isDataAccessible('investments.initial_value'),
    roi: !isDataAccessible('investments.roi'),
    moic: !isDataAccessible('investments.moic'),
    initialPrice: !isDataAccessible('investments.initial_price'),
    initialShares: !isDataAccessible('investments.initial_shares'),
    initialCapital: !isDataAccessible('investments.initial_capital'),
    distributions: !isDataAccessible('investments.distributions'),
    accruedInterest: !isDataAccessible('investments.accrued_interest'),
  }))

  return { hidden_keys, isDataAccessible, hidden }
}
